import { render, staticRenderFns } from "./CategoryTemplateDescription.vue?vue&type=template&id=ee1fbc7e&"
import script from "./CategoryTemplateDescription.vue?vue&type=script&lang=js&"
export * from "./CategoryTemplateDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports